<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                        <div class="stickyside" style="top: 120px;">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><vendor-sidebar></vendor-sidebar></div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-md-7 col-lg-8 col-xl-9">
                        <div>
                            <h2>Espaces</h2>
                        </div>
                        <hr class="mt-0"/>

                        <div class="d-flex justify-content-center align-items-center">
                            <a v-for="tab in tabs" @click="activeTab=tab.id;getEstablishments(tab.is_verified);currentPage=1" :class="{ 'bg-warning-light': activeTab === tab.id }" 
                                href="javascript:void(0)" class="badge badge-pill text-dark bg-light text-xs mr-1 py-3 px-4">{{ tab.label }}</a>
                        </div>
                        <div class="tab-content">
                            <div class="tab-pane fade show active pt-2">
                                <div v-if="paginatedData.length === 0" class="text-center mb-5">
                                    <span class="text-sm d-block mb-4 mt-2">Aucun espace.</span>
                                </div>
                                <div v-else class="mb-5">
                                    <div class="table-responsive text-xs p-0 pt-2">
                                        <table class="table table-hover table-center mb-0">
                                            <thead class="bg-light">
                                                <tr>
                                                    <th>Espace</th>
                                                    <th>Délégation</th>
                                                    <th>Email - N°Tél./Whatsapp </th>
                                                    <th>Créé le</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in paginatedData" :key="item.id">
                                                    <td style="min-width: 160px;" class="position-relative">
                                                        <a :href="'/my/establishment/' + item.id" class="stretched-link"></a>
                                                        <div class="d-flex justify-content-start mb-1">
                                                            <img :src="item.logo_url || defaultLogo" width="40px" height="40px" class="bg-white rounded-lg p-1 d-inline-block mr-2">
                                                            <div class="d-flex flex-column justify-content-center">
                                                                <span>{{ item.business_name }}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style="min-width: 120px;max-width: 140px;">
                                                        <div class="d-flex flex-column">
                                                            <span>{{ item.delegation.split(', ')[0] }}</span>
                                                            <span class="text-muted">{{ item.delegation.split(', ')[1] }}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="d-flex flex-column">
                                                            <span class="d-flex align-items-center"><span class="material-symbols-outlined text-sm mr-1">mail</span>{{ item.email || item.owner.email }}</span>
                                                            <span class="d-flex align-items-center"><span class="material-symbols-outlined text-sm mr-1">call</span>{{ item.phone_number || item.owner.phone_number }}</span>
                                                            <span class="d-flex align-items-center"><i class="fab fa-whatsapp mr-1"></i>{{ item.owner.whatsapp_number }}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{ formatDateTime(item.created_at).date }}
                                                        <span class="d-block text-muted">à {{ formatDateTime(item.created_at).time }}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- PAGINATION -->
                                    <nav class="mt-3 mb-2">
                                        <ul class="pagination justify-content-center">
                                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                <button class="page-link text-dark" @click="goToPage(currentPage - 1)">
                                                    <span class="material-symbols-outlined text-sm">arrow_back</span>
                                                </button>
                                            </li>
                                            <li class="page-item">
                                                <select class="page-link text-dark text-xs h-100" v-model="currentPage" @change="goToPage(Number(currentPage))">
                                                    <option v-for="page in totalPages" :key="page" :value="page">
                                                        Page {{ page }}
                                                    </option>
                                                </select>
                                            </li>
                                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                                <button class="page-link text-dark" @click="goToPage(currentPage + 1)">
                                                    <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-md-7 col-lg-8 col-xl-9">
                        <div>
                            <h2>Réservations</h2>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-md-12">
                                <div class="bookings">

                                    <div class="card card-table">
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <table class="table table-hover table-center mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Reservation par</th>
                                                            <th>Terrain</th>
                                                            <th>Pour le</th>
                                                            <th>Créée le</th>
                                                            <th>Statut</th>
                                                            <th>Paiement</th>
                                                            <th>À Travers</th>
                                                            <th>Montant (Payé)</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="booking in bookings" :key="booking.id">
                                                            <td>
                                                                <h2 class="table-avatar">
                                                                    <span class="avatar avatar-sm me-2 mr-2">
                                                                        <img class="avatar-title rounded-circle"
                                                                            :src="loadImg('client8.jpg')"
                                                                            alt="User Image" />
                                                                    </span>
                                                                    <p>
                                                                        {{ booking.first_name }}<br />
                                                                        <span>{{ booking.last_name }}</span>
                                                                    </p>
                                                                </h2>
                                                            </td>
                                                            <td>
                                                                <h2 class="table-avatar">
                                                                    <span class="avatar avatar-sm mr-2">
                                                                        <img class="avatar-img"
                                                                            :src="loadImage(booking.stadium_logo)"
                                                                            alt="Stadium Logo" />
                                                                    </span>
                                                                    <a href="javascript:void(0)">{{ booking.business_name }}
                                                                        <span>{{ booking.field_name }}</span></a>
                                                                </h2>
                                                            </td>
                                                            <td>
                                                                {{ formatDateTime(booking.start_time).date }}
                                                                <span class="d-block text-info">
                                                                    {{ formatDateTime(booking.start_time).time }} -
                                                                    {{ formatDateTime(booking.end_time).time }}
                                                                </span>
                                                            </td>
                                                            <td>{{ formatDateTime(booking.created_at).datetime }}</td>
                                                            <td>
                                                                <span class="badge badge-pill p-2" :class="{
                                                                    'bg-success-light': ['completed', 'confirmed'].includes(booking.booking_status),
                                                                    'bg-warning-light': ['pending', 'pending approval', 'awaiting payment'].includes(booking.booking_status),
                                                                    'bg-danger-light': ['expired', 'no show', 'cancelled', 'aborted', 'rejected', 'payment failed'].includes(booking.booking_status)
                                                                }">
                                                                    {{ booking_status[booking.booking_status] }}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span v-if="booking.payment_method === 'cash'">En
                                                                    Espèces"</span>
                                                                <span v-if="booking.payment_method === 'online'">En
                                                                    Ligne</span>
                                                                <span
                                                                    v-if="booking.payment_method === 'refund voucher'">Bon
                                                                    d'Achat</span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    v-if="booking.channel === 'website'"><b>6v6</b></span>
                                                                <span v-else>Partenaire</span>
                                                            </td>
                                                            <td>
                                                                {{ booking.price }}<sup>DT</sup>
                                                                <span class="ml-1"
                                                                    v-if="['online', 'refund voucher'].includes(booking.payment_method)">
                                                                    ({{ booking.paid }}<sup>DT</sup>)
                                                                </span>
                                                            </td>
                                                            <td class="text-end">
                                                                <div class="table-action">
                                                                    <a @click="noShowBooking(booking)" v-if="['confirmed', 'completed'].includes(booking.booking_status) &&
                                                                        formatDateTime(booking.start_time).datetime < todayDateTime"
                                                                        class="btn btn-sm bg-info-light ms-1">
                                                                        Absence
                                                                    </a>
                                                                    <a @click="cancelBooking(booking)" v-if="booking.channel != 'vendor' &&
                                                                        ['confirmed', 'completed'].includes(booking.booking_status) &&
                                                                        formatDateTime(booking.start_time).datetime > todayDateTime"
                                                                        class="btn btn-sm bg-danger-light ms-1">
                                                                        Annuler
                                                                    </a>
                                                                    <div
                                                                        v-if="['pending approval'].includes(booking.booking_status)">
                                                                        <div
                                                                            v-if="formatDateTime(booking.start_time).date >= todayDate">
                                                                            <a @click="confirmBooking(booking)"
                                                                                class="btn btn-sm bg-success-light mr-1">
                                                                                <i class="fas fa-check"></i> Accepter
                                                                            </a>
                                                                            <a @click="rejectBooking(booking)"
                                                                                class="btn btn-sm bg-danger-light">
                                                                                <i class="fas fa-times"></i> Rejeter
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <p class="d-block text-center p-2 pb-3" v-if="bookings.length === 0">Pas de
                                                réservations</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>
</template>
<style scoped>
.sender-img {
    -ms-flex: 0 0 100px;
    flex: 0 0 100px;
    width: 100px;
}

.success {
    background-color: #b5fcbf63;
}

.gray {
    background-color: #e1e1e1;
}

.red {
    background-color: #ffe1e1;
}
</style>
<script>
import axios from "axios";
import moment from "moment";
import VendorSidebar from "@/components/Vendors/Partials/Sidebar";
import defaultLogoPath from '@/assets/img/photo.png'
import { api } from "@/store";
// const images = require.context("@/assets/img/clients", false, /\.png$|\.jpg$/);
// axios.defaults.withCredentials = true; // Ensure cookies are sent with the request

export default {
    components: {
        "vendor-sidebar": VendorSidebar,
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        totalPages() {
            return Math.ceil(this.establishments.length / this.perPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.establishments.slice(start, start + this.perPage);
        }
    },
    created() {
        this.getEstablishments();
    },
    mounted() {
        // this.get_stadiums()
    },
    data() {
        return {
            defaultLogo: defaultLogoPath,
            activeTab: 'verified',
            tabs: [
                { id: 'verified', label: 'Vérifiés', is_verified: true },
                { id: 'unverified', label: 'Non-Vérifiés', is_verified: false },
            ],
            establishments: [],
            currentPage: 1,     // selected page
            perPage: 5,         // items per page
        };
    },
    methods: {
        getEstablishments(is_verified = true) {
            api.get("/private/establishment/list")
                .then(response => {
                    const result = response.data;
                    this.establishments = result.filter(e => e.is_verified === is_verified)
                });
        },
        formatDateTime(datetimeString) {
            if (!datetimeString) return "";
            const date = new Date(datetimeString);
            const formattedDate = date.toISOString().split("T")[0];
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            let date_obj = {
                date: formattedDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` à ${hours}:${minutes}`,
            };
            return date_obj;
        },
        addToDate(datetimeString, count, unit) {
            const datetime = moment(datetimeString).add(count, unit)
            return datetime.format('YYYY-MM-DDTHH:mm:ss')
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
    },
};
</script>
